import type { CabinBaggageTripSummary } from '@eti/schema-types';
import { CabinBaggageStatus } from '@eti/schema-types';

const isCabinBaggageNotIncluded = (
  cabinBaggageTripSummary: CabinBaggageTripSummary,
  showNotIncludedProducts: Boolean,
) => {
  if (
    showNotIncludedProducts &&
    cabinBaggageTripSummary &&
    !(
      cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
        CabinBaggageStatus.NoCabinBaggage ||
      cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
        CabinBaggageStatus.NoCabinBaggageAvailable
    )
  ) {
    return false;
  }
  return true;
};

export default isCabinBaggageNotIncluded;
